import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Text } from "../Text/Text";
import { TEXT } from "../../../static/contents/text";
import * as styles from "./contactD.module.scss";

export const ContactD: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div className={styles.icons}>
          <a
            href={
              "https://www.facebook.com/europeanassociationforosseointegration"
            }
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a
            href={"https://www.instagram.com/eao_association/</div>"}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a
            href={"https://www.youtube.com/channel/UCpB-t6R4nQcO_yZskip1lqA"}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faYoutube} />
          </a>
          <a
            href={"https://twitter.com/EAO_Association"}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a
            href={
              "https://www.linkedin.com/company/eao-european-association-for-osseointegration/"
            }
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedinIn} />
          </a>
        </div>
        <div className={styles.address}>
          <Text text={TEXT.text91} className={styles.special} />
          <Text text={TEXT.text92} />
          <Text text={TEXT.text921} />
          <Text text={TEXT.text922} />
          <Text text={TEXT.text923} className={styles.gap} />
        </div>
      </div>
      <div className={styles.right}>
        <Text text={TEXT.text9} className={styles.gap} />
        <div className={styles.group}>
          <a
            href={"https://eao.org/pages/terms-conditions/"}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.different}
          >
            <Text text={TEXT.text93} className={styles.different} />
          </a>
          <div className={styles.baton}>{"|"}</div>
          <a
            href={"https://eao.org/pages/privacy-policy/"}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.different}
          >
            <Text text={TEXT.text94} className={styles.different} />
          </a>
          {/* <div className={styles.baton}>{"|"}</div>
          <Text text={TEXT.text95} className={styles.different} /> */}
        </div>
      </div>
    </div>
  );
};
